(function () {
  var form = document.getElementById('hb-filter-form');
  if (!form) return;

  var debounceTimer;

  form.addEventListener('change', function (e) {
    if (e.target.matches('input[type="checkbox"]')) {
      form.submit();
    }
  });

  function formatMoney(value) {
    var cents = Math.round(value * 100);
    if (window.Shopify && Shopify.formatMoney && Shopify.money_format) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    return value.toFixed(2).replace('.', ',') + ' €';
  }

  form.querySelectorAll('[data-hb-range-slider]').forEach(function (slider) {
    var maxInput = slider.querySelector('[data-hb-range-input="max"]');
    var fill = slider.querySelector('[data-hb-range-fill]');
    var thumb = slider.querySelector('[data-hb-range-thumb]');
    var hint = slider.parentElement.querySelector('.hb-filter-price__hint');
    var maxLabel = hint ? hint.querySelector('[data-hb-range-label="max"]') : null;
    var rangeMax = parseFloat(slider.dataset.max) || 1;

    function paint() {
      var maxVal = parseFloat(maxInput.value);
      var percent = (maxVal / rangeMax) * 100;
      fill.style.width = percent + '%';
      if (thumb) thumb.style.left = percent + '%';

      if (maxLabel) maxLabel.textContent = formatMoney(maxVal);
    }

    maxInput.addEventListener('input', paint);
    paint();

    maxInput.addEventListener('change', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        form.submit();
      }, 200);
    });
  });
})();